import React from 'react';
import TableManager from '../components/data/TableManager'; // Adjust the path as necessary

// Configuration for SKE_Moduli columns based on the provided SQL DDL
const columnConfig = [
  // --- Keys and Identifiers ---
  "MOD_Id_Moduli=1,ID", // PK, only in form/detail
  "MOD_IdRif_Moduli=1,ID Rif.", // Only in form/detail
  "MOD_CodiceModulo=2,Codice", // Visible in table
  "MOD_DescrizioneModulo=2,Descrizione", // Visible in table
  "MOD_SchemaDB=2,Schema DB", // Visible in table
  "MOD_Libreria=2,Libreria", // Visible in table
  "MOD_InizioValidita=2,Inizio Validità,type=date", // Visible in table
  "MOD_FineValidita=1,Fine Validità,type=datetime", // Only in form/detail

  // --- Status ---
  "MOD_StatiRecord=2,Stato Record", // Visible in table, potentially a lookup

  // --- Audit Fields (Hidden, managed by backend/trigger) ---
  "MOD_UtenteInserimento=0,Utente Inserimento",
  "MOD_TerminaleInserimento=0,Terminale Inserimento",
  "MOD_DataInserimento=0,Data Inserimento",
  "MOD_UtenteModifica=0,Utente Modifica",
  "MOD_TerminaleModifica=0,Terminale Modifica",
  "MOD_DataModifica=0,Data Modifica",
  "MOD_Timestamp=0,Timestamp",
];

// Configuration for Filters
const filterConfig = [
  { field: 'MOD_CodiceModulo', label: 'Codice', type: 'text' },
  { field: 'MOD_DescrizioneModulo', label: 'Descrizione', type: 'text' },
  { field: 'MOD_SchemaDB', label: 'Schema DB', type: 'text' },
  { field: 'MOD_Libreria', label: 'Libreria', type: 'text' },
  { field: 'MOD_StatiRecord', label: 'Stato Record', type: 'lookup', lookupName: 'statiRecord' }, // Assuming a lookup
];

// Configuration for Lookups
const lookupConfig = {
  statiRecord: {
    // Assuming statiRecord uses fixed options or needs a dedicated table
    // Option 1: Fixed options if no dedicated table exists
    options: [
      { value: 1, label: 'Attivo' }, // Example: Assuming 1 means Active
      { value: 0, label: 'Inattivo' }, // Example: Assuming 0 means Inactive
      // Add other status codes and labels as needed
    ],
    // Option 2: If a dedicated table like 'SKE_StatiRecord' exists
    // tableName: 'SKE_StatiRecord',
    // valueField: 'STR_Id_StatoRecord', // Adjust field names accordingly
    // labelField: 'STR_Descrizione', // Adjust field names accordingly
  }
};

// Specific Input Types for Form Fields
const inputTypes = {
  MOD_DescrizioneModulo: 'textarea',
  MOD_RifModuli: 'number',
  MOD_StatiRecord: 'number', // Or handled by lookup component
  MOD_InizioValidita: 'date', // HTML5 date input
  MOD_FineValidita: 'datetime-local', // HTML5 datetime input
};

const ModuliPage = () => {
  return (
    <TableManager
      tableName="SKE_Moduli"
      primaryKey="MOD_Id_Moduli"
      pageTitle="Gestione moduli "
      columnConfig={columnConfig}
      filterConfig={filterConfig}
      lookupConfig={lookupConfig}
      inputTypes={inputTypes}
      enableCreate={true}
      enableEdit={true}
      enableDelete={true}
      // initialFilters={{ MOD_StatiRecord: 1 }} // Example: Show only active records initially
    />
  );
};

export default ModuliPage;